import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useAdminPurchaseDetail(id) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [related, setRelated] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPurchaseDetail = useCallback(async (id) => {
    setLoading(true);

    try {
      const { response, data } = await API.admin.fetchPurchase(token, id);

      if (response.ok) {
        setResult(data.purchase);
        setRelated(data.related);
        setError(null);
      } else {
        setResult(null);
        setError(data.message);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPurchaseDetail(id);
  }, [token, id]);

  return {
    loading,
    error,
    purchase: result ?? null,
    related: related ?? [],
  };
}
